/**
 * Typed client errors that can bubble to the root route error boundary.
 */

export type AppErrorOptions = {
  code?: string;
  status?: number;
  cause?: unknown;
};

export class AppError extends Error {
  readonly code?: string;
  readonly status?: number;

  constructor(message: string, options: AppErrorOptions = {}) {
    super(
      message,
      options.cause !== undefined ? { cause: options.cause } : undefined
    );
    this.name = "AppError";
    this.code = options.code;
    this.status = options.status;
  }
}

export function isAppError(error: unknown): error is AppError {
  return error instanceof AppError;
}

/** Build an AppError from a BFF/Dust-style JSON error body. */
export function appErrorFromResponseBody(
  status: number,
  errorData: unknown
): AppError {
  const body = errorData as {
    error?: { type?: string; message?: string } | string;
  } | null;

  let message: string;
  let code: string | undefined;

  if (body?.error && typeof body.error === "object") {
    if (typeof body.error.message === "string" && body.error.message) {
      message = body.error.message;
    } else {
      message = `HTTP error! status: ${status}`;
    }
    if (typeof body.error.type === "string" && body.error.type) {
      code = body.error.type;
    }
  } else if (typeof body?.error === "string" && body.error) {
    message = body.error;
  } else {
    message = `HTTP error! status: ${status}`;
  }

  return new AppError(message, { code, status });
}
